import { render, staticRenderFns } from "./BlockSection.vue?vue&type=template&id=4ba84d2a&scoped=true&"
var script = {}
import style0 from "./BlockSection.vue?vue&type=style&index=0&id=4ba84d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba84d2a",
  null
  
)

export default component.exports